import { render, staticRenderFns } from "./GeneralJobCards.vue?vue&type=template&id=ff267132&"
import script from "./GeneralJobCards.vue?vue&type=script&lang=js&"
export * from "./GeneralJobCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports